<template>
  <header>
    <div class=app_0>
      <div class="row app_row">
        <div class="col">
          <router-link to="home">
            <img alt="Vue logo" src="../assets/title.png" class="title">
          </router-link>
        </div>
        <div class="group_logo col">
          <router-link to="home">
            <img alt="Home icon" class="icon_home" src="../assets/icon/icon_home1.png">
          </router-link>

          <router-link to="gallery">
            <img alt="gallery icon" class="icon_gallery" src="../assets/icon/icon_gallery2.png">
          </router-link>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  export default {
    name: 'site-header',
  }
</script>

<style scoped>
  .title{
    width:250px;
    height:auto;
    padding-left:2%;
    padding-top:1%;
    /* padding-bottom:1%; */
  }
  .app_0 {
    border-radius: 1%;
    background-color: #88dce9b9;
    opacity:0.9;
    position: sticky;
  }
  .app_row{
    padding:10px;
    margin-right:15px;
  }
  .icon_home{
    width:60px;
    /* margin-top:15%; */
    margin-right:20px;
  }
  .icon_gallery{
    width:60px;
    /* margin-top:15%; */
    margin-left:20px;
  }
  .header {
    color: #fff;
    position: sticky;
  }
  .group_logo{
    margin:0 0 0 auto;
    margin-left: 50%;
    /* padding-bottom:20px; */
  }
</style>